import { render, staticRenderFns } from "./clients-table.vue?vue&type=template&id=3ef3bfe0&scoped=true"
import script from "./clients-table.vue?vue&type=script&lang=js"
export * from "./clients-table.vue?vue&type=script&lang=js"
import style0 from "./clients-table.vue?vue&type=style&index=0&id=3ef3bfe0&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef3bfe0",
  null
  
)

export default component.exports